import { Alert } from '@designsforhealth/dfh-react-components'
import React, { useEffect } from 'react'
import { take } from 'rxjs'

import ErrorRetrievingDataMessage from '../components/ErrorRetrievingDataMessage'
import Spinner from '../components/Spinner'
import { NonEmptyCartContext, useCartContext } from '../lib/cart'
import { placeOrderTaskApplicationLoading$ } from '../lib/cart/state/order'
import { useDispensaryCartStatus } from '../lib/dispensaries/events/cart'
import { usePageUrl } from '../lib/pages'

const NonEmptyCartContextProvider: React.FC = ({ children }) => {
  const { navigate } = usePageUrl()
  const { cart, error: cartError } = useCartContext()
  const { loading: dispensaryCartLoading, error: dispensaryCartError } = useDispensaryCartStatus()

  useEffect(() => {
    const subscription = placeOrderTaskApplicationLoading$.subscribe()
    return () => subscription.unsubscribe()
  }, [])

  // Redirect to cart screen if the cart is empty
  useEffect(() => {
    if (!cart?.items?.length) {
      placeOrderTaskApplicationLoading$.pipe(take(1)).subscribe((placeOrderInProgress) => {
        if (!placeOrderInProgress) {
          navigate('/checkout')
        }
      })
    }
  }, [navigate, cart])

  if (cartError || dispensaryCartError) {
    return (
      <Alert type="error">
        <ErrorRetrievingDataMessage />
      </Alert>
    )
  }

  // cart is not ready if dispensary cart changes still in progress
  if (!cart || dispensaryCartLoading) {
    return <Spinner loading />
  }

  return <NonEmptyCartContext.Provider value={cart}>{children}</NonEmptyCartContext.Provider>
}

export default NonEmptyCartContextProvider
